import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { TranslocoModule } from '@jsverse/transloco';
import { MyOverlayRef } from '../my-overlay-ref';
import { OverlayService } from '../overlay.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'aipb-overlay-manager',
  templateUrl: './overlay-manager.component.html',
  styleUrls: ['./overlay-manager.component.scss'],
  imports: [
    CommonModule,
    DragDropModule,
    OverlayModule,
    MatListModule,
    MatButtonModule,
    PortalModule,
    TranslocoModule,
    MatIconModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayManagerComponent {
  private document = inject(DOCUMENT);
  private overlayService = inject(OverlayService);
  overlays$ = this.overlayService.overlays$;

  onClose(ref: MyOverlayRef) {
    this.overlayService.close(ref.id);
  }

  onCloseAll() {
    this.overlayService.closeAll();
  }

  onMaximize(overlay: MyOverlayRef<any, any>) {
    overlay.maximize(this.document);
  }

  onResetAll() {
    this.overlayService.resetAll();
  }
}
